import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../../ui/accordion";

export default function AdvancedSection({ title = "Avanzado (tabla, parámetros, campo resultado)", children }) {
  return (
    <Accordion type="single" collapsible className="mt-4">
      <AccordionItem value="avanzado">
        <AccordionTrigger className="text-sm text-gray-500">{title}</AccordionTrigger>
        <AccordionContent>
          <div className="pt-2 space-y-4">{children}</div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
